module.exports = __webpack_public_path__ + "img/弘阳地产.3976f5b2.png";